/* ON:PACE on the homepage: route -> room -> orbit (sections/onpace-home-showcase.liquid).
   GEO: where the KAZE 7's screen and console sit in the room photo (percent of the photo), measured for
   the pre-order ads (k7-hero-zoom quad). END: where each Feature Orbit film's end-card photo sits in the
   film frame (registered against the 16:9 master), so the photo can take over from the film and grow to
   full bleed without a jump. Both are tied to those exact images: re-measure if a photo changes. */
(function(){
  var SCRIPT = document.currentScript;
  var GEO = {"desk":{"aspect":1.7777,"quad":[46.237,29.4596,7.7641,6.6732],"detail":[35.4697,19.5312,29.2987,26.0417],"radius":0.0189},"mob":{"aspect":0.5625,"quad":[37.7315,29.4596,24.537,6.6732],"detail":[3.7037,19.5312,92.5926,26.0417],"radius":0.0189}};
  var END = {"kaze7":{"mw":5461,"mh":3072,"16x9":{"fw":1920,"fh":1080,"scale":0.4625,"origin":[62.0,-168.0]},"9x16":{"fw":1080,"fh":1920,"scale":0.45,"origin":[-731.0,618.0]}},"kaze5":{"mw":5461,"mh":3072,"16x9":{"fw":1920,"fh":1080,"scale":0.4625,"origin":[130.0,-172.0]},"9x16":{"fw":1080,"fh":1920,"scale":0.45,"origin":[-667.0,618.0]}},"soyo5":{"mw":2400,"mh":1350,"16x9":{"fw":1920,"fh":1080,"scale":0.9625,"origin":[214.0,-56.0]},"9x16":{"fw":1080,"fh":1920,"scale":0.95,"origin":[-601.0,722.0]}}};
  var BOX = { '16x9':[820/1920,0,1,1], '9x16':[0,700/1920,1,1] };   // the end card's photo box in each film
  var T = { zoomA:.08, zoomB:.46, handA:.56, handB:.66 };            // timeline, as a share of the scroll

  function clamp(x,a,b){ return Math.max(a,Math.min(b,x)); }
  function ease(t){ return t<.5 ? 2*t*t : 1-Math.pow(-2*t+2,2)/2; }
  function band(p,a,b){ return clamp((p-a)/(b-a),0,1); }

  function init(root){
    var q$=function(s){ return root.querySelector(s); };
    var track=q$('.ohx__track'), sticky=q$('.ohx__sticky'), stage=q$('[data-stage]'), scene=q$('[data-scene]'),
        screen=q$('[data-screen]'), detail=q$('[data-detail]'), shade=q$('[data-shade]'),
        orbitWrap=q$('[data-orbit-wrap]'), paper=q$('[data-paper]'), bar=q$('.ohx__bar'), orbit=q$('[data-orbit]'), veil=q$('[data-veil]'), endBox=q$('[data-end]'), endImg=q$('[data-end-img]'),
        replay=q$('[data-replay]'), A=q$('[data-line-a]'), B1=q$('[data-line-b1]'), B2=q$('[data-line-b2]'),
        place=q$('[data-place-label]'), placeName=q$('[data-place-name]'), hint=q$('[data-hint]'), note=q$('[data-note]'),
        steps=q$('[data-steps]'), stepEls=steps?steps.querySelectorAll('li'):[], LA=q$('[data-layer-a]'), LB=q$('[data-layer-b]'),
        tabs=[].slice.call(root.querySelectorAll('.ohx__tabs button')), cta=q$('[data-cta]'), priceEl=q$('.ohx__price [data-price]'), wasEl=q$('.ohx__price [data-was]');   // not the tab buttons, which carry the same data attributes
    var prefix=(SCRIPT && SCRIPT.dataset.ctaPrefix) || 'Shop';
    var vids=screen?[].slice.call(screen.querySelectorAll('video')):[], cur=0;
    var only=root.hasAttribute('data-orbit-only');   // homepage: the orbit films alone (the route pull-back lives on the collection page)
    // ---- Kinomap overlay: the readouts follow the route's own data as the clip plays ----
    var hudUI=q$('[data-hud-ui]'), HU={};
    if (hudUI) ['k-dur','ohk-sec','k-spd','k-dst','k-gain','k-inc','k-slope'].forEach(function(c){ HU[c]=hudUI.querySelector('.'+c); });
    var bars=hudUI ? [].slice.call(hudUI.querySelectorAll('.k-bars i')) : [];
    function pad2(x){ return (x<10?'0':'')+x; }
    function slopeColour(g){ return g<-1?'#3B8BF5':g<1.5?'#38B64C':g<4?'#F2C230':g<8?'#F08B2C':'#E2483A'; }
    function hud(v){
      if (!hudUI) return;
      var D=v.__hud; if (D===undefined){ try{ D=v.__hud=JSON.parse(v.dataset.hud||'null'); }catch(e){ D=v.__hud=null; } }
      hudUI.style.visibility=D ? 'visible' : 'hidden'; if (!D) return;
      var d=D.d, t=D.t0+(v.currentTime||0), k=0, g=D.g0||0, i;
      while (k<d.length-2 && d[k+1][0]<=t) k++;
      for (i=1;i<=k;i++) g+=Math.max(0, d[i][2]-d[i-1][2]);
      var a=d[k], b=d[Math.min(k+1,d.length-1)], f=b[0]>a[0] ? clamp((t-a[0])/(b[0]-a[0]),0,1) : 0;
      var dist=a[1]+(b[1]-a[1])*f, kmh=a[3]+(b[3]-a[3])*f, slope=a[4]+(b[4]-a[4])*f, mx=D.max||15, inc=clamp(slope,0,mx), el=Math.floor(t);
      HU['k-dur'].textContent=Math.floor(el/60); HU['ohk-sec'].textContent=':'+pad2(el%60);
      HU['k-spd'].textContent=kmh.toFixed(1);
      var du=HU['k-dst'].parentNode.querySelector('.ohk-u');
      if (dist>=1000){ HU['k-dst'].textContent=(dist/1000).toFixed(2); du.textContent='km'; } else { HU['k-dst'].textContent=Math.round(dist); du.textContent='m'; }
      HU['k-gain'].textContent=Math.round(g); HU['k-inc'].textContent=Math.round(inc);
      var lit=Math.round(inc/mx*bars.length); bars.forEach(function(x,j){ x.className=bars.length-j<=lit?'on':''; });
      HU['k-slope'].textContent=(slope>0?'+':'')+slope.toFixed(1)+'%'; HU['k-slope'].style.background=slopeColour(slope);
    }
    vids.forEach(function(v){ v.addEventListener('timeupdate', function(){ if (v.classList.contains('on')) hud(v); }); });
    var mq=window.matchMedia('(max-width:749px)'), reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var tab=tabs.filter(function(b){ return b.getAttribute('aria-selected')==='true'; })[0] || tabs[0];
    var g, sw, sh, sceneW, sceneH, q, card, hh=0, avail=0, pin='', orbitOn=false, inView=false, near=false, ending=null, done=false, lastP=0, pDone=0, raf=0;

    function ratio(){ return mq.matches ? '9x16' : '16x9'; }
    // clips start once the page has loaded (or after 2.5 s at most), so they never compete with the homepage's first paint
    var vidsGo=document.readyState==='complete', vidsWait=[];
    function vidsStart(){ if(vidsGo) return; vidsGo=true; vidsWait.splice(0).forEach(function(v){ load(v); if(v.classList.contains('on') && inView) v.play().catch(function(){}); }); }
    if(!vidsGo){ addEventListener('load', function(){ setTimeout(vidsStart, 200); }, {once:true}); setTimeout(vidsStart, 2500); }
    function load(v){ if(!v || v.getAttribute('src') || !v.dataset.src) return; if(!vidsGo){ if(vidsWait.indexOf(v)<0) vidsWait.push(v); return; } v.src=v.dataset.src; v.preload='auto'; }

    // the site header is fixed once you scroll; the section pins underneath it
    function headerBottom(){
      var hs=document.querySelectorAll('#header, #mobile-header'), b=0;
      for (var i=0;i<hs.length;i++){ var e=hs[i], r=e.getBoundingClientRect();
        if (r.height && r.top<=2 && r.bottom>0 && /fixed|sticky/.test(getComputedStyle(e).position)) b=Math.max(b, r.bottom); }
      return Math.round(b);
    }
    function layout(){
      hh=headerBottom(); avail=window.innerHeight-hh; sticky.style.height=avail+'px';
      g = mq.matches ? GEO.mob : GEO.desk;
      var cs=getComputedStyle(sticky),
          aw=sticky.clientWidth-parseFloat(cs.paddingLeft)-parseFloat(cs.paddingRight),
          ah=sticky.clientHeight-parseFloat(cs.paddingTop)-parseFloat(cs.paddingBottom);
      sw=aw; sh=ah;                                                  // full bleed: the whole width, the height under the header
      stage.style.width=sw+'px'; stage.style.height=sh+'px';
      if (sw/sh > g.aspect){ sceneW=sw; sceneH=sw/g.aspect; } else { sceneH=sh; sceneW=sh*g.aspect; }
      scene.style.width=sceneW+'px'; scene.style.height=sceneH+'px';
      var Q=g.quad, D=g.detail;
      q={x:Q[0]/100*sceneW, y:Q[1]/100*sceneH, w:Q[2]/100*sceneW, h:Q[3]/100*sceneH};
      var gx=q.w*.008, gy=q.h*.012; q={x:q.x-gx, y:q.y-gy, w:q.w+2*gx, h:q.h+2*gy};   // cover the rim of the original screen art
      screen.style.cssText='left:'+q.x+'px;top:'+q.y+'px;width:'+q.w+'px;height:'+q.h+'px;border-radius:'+(g.radius*q.w)+'px';
      detail.style.cssText='left:'+D[0]/100*sceneW+'px;top:'+D[1]/100*sceneH+'px;width:'+D[2]/100*sceneW+'px;height:'+D[3]/100*sceneH+'px';
      // the films' card: their own shape, centred, with a margin of paper on desktop
      var pad=mq.matches?0:20, ca=mq.matches?9/16:16/9, cw=Math.min(sw-2*pad, (sh-2*pad)*ca, 1560), ch=cw/ca;
      card={x:(sw-cw)/2, y:(sh-ch)/2, w:cw, h:ch};
      orbitWrap.style.cssText='left:'+card.x+'px;top:'+card.y+'px;width:'+card.w+'px;height:'+card.h+'px;right:auto;bottom:auto';
      if (orbit.getAttribute('src')) setFilm(false);
      update();
    }

    // ---- films ----
    function setFilm(play){
      var m=mq.matches, want=m ? tab.dataset.filmM : tab.dataset.film;
      cancelEnd();
      if (orbit.getAttribute('src')!==want){ orbit.poster=(m ? tab.dataset.posterM : tab.dataset.poster)||''; orbit.setAttribute('src', want); orbit.load(); }
      if (play){ try{ orbit.currentTime=0; }catch(e){} orbit.play().catch(function(){}); }
    }
    // the film fills its card exactly, so film-frame pixels scale straight into the card
    function endPlacement(){
      var e=END[tab.dataset.key], r=ratio(), f=e[r], k=card.w/f.fw, s0=f.scale, o0=f.origin;
      var sc=Math.max(f.fw/e.mw, f.fh/e.mh), b=BOX[r], mx=(((b[0]+b[2])/2*f.fw)-o0[0])/s0;
      var ox=clamp(f.fw/2 - mx*sc, f.fw - e.mw*sc, 0), oy=(f.fh - e.mh*sc)/2;
      return { a:{w:e.mw*s0*k, h:e.mh*s0*k, x:o0[0]*k, y:o0[1]*k}, b:{w:e.mw*sc*k, h:e.mh*sc*k, x:ox*k, y:oy*k},
               clip:'inset('+(b[1]*100)+'% '+((1-b[2])*100)+'% '+((1-b[3])*100)+'% '+(b[0]*100)+'%)' };
    }
    function setBox(r){ endImg.style.width=r.w+'px'; endImg.style.height=r.h+'px'; endImg.style.left=r.x+'px'; endImg.style.top=r.y+'px'; }
    function startEnd(){
      if (ending || !END[tab.dataset.key]) return;
      var P=endPlacement();
      orbit.pause();                                               // freeze before the baked end card can show
      endImg.src=tab.dataset.end;
      endImg.style.transition='none'; endBox.style.transition='none';
      setBox(P.a); endBox.style.clipPath=P.clip; endBox.style.opacity='0';
      void endBox.offsetWidth;
      veil.style.transition='opacity .3s ease'; veil.style.opacity='1';
      endBox.style.transition='opacity .35s ease'; endBox.style.opacity='1';
      var ez='cubic-bezier(.65,0,.35,1)';
      ending={ t1:setTimeout(function(){
          endImg.style.transition='left 1.4s '+ez+',top 1.4s '+ez+',width 1.4s '+ez+',height 1.4s '+ez;
          endBox.style.transition='clip-path 1.4s '+ez;
          setBox(P.b); endBox.style.clipPath='inset(0% 0% 0% 0%)';
        }, 380),
        t2:setTimeout(function(){ done=true; pDone=lastP; replay.style.opacity='0'; replay.style.pointerEvents='none'; replay.hidden=false; update(); }, 380+1400) };
    }
    function cancelEnd(){
      done=false; replay.style.opacity='0'; replay.hidden=true;
      if (!ending) return;
      clearTimeout(ending.t1); clearTimeout(ending.t2); ending=null;
      endBox.style.transition='none'; endBox.style.opacity='0'; veil.style.transition='none'; veil.style.opacity='0';
    }
    orbit.addEventListener('timeupdate', function(){ if (orbit.duration && orbit.currentTime >= orbit.duration-2.1) startEnd(); });   // the camera has landed; the baked end card starts at -1.5 s
    replay.addEventListener('click', function(){
      endBox.style.transition='opacity .6s ease'; endBox.style.opacity='0'; veil.style.transition='opacity .6s ease'; veil.style.opacity='0';
      done=false; ending=null; replay.style.opacity='0'; replay.style.pointerEvents='none'; setTimeout(function(){ replay.hidden=true; }, 400);
      try{ orbit.currentTime=0; }catch(e){} orbit.play().catch(function(){});
    });
    tabs.forEach(function(b){ b.addEventListener('click', function(){
      tabs.forEach(function(x){ x.setAttribute('aria-selected', String(x===b)); });
      tab=b; priceEl.textContent=b.dataset.price; wasEl.textContent=b.dataset.was||'';
      cta.textContent=prefix+' '+b.dataset.name; cta.href=b.dataset.url; setFilm(true);
    }); });

    // ---- routes take turns; only the playing clip and the next one are loaded ----
    function show(i){
      vids.forEach(function(v,j){ v.classList.toggle('on', j===i); if (j!==i) v.pause(); });
      var v=vids[i]; load(v); try{ v.currentTime=0; }catch(e){} v.play().catch(function(){});
      var nx=vids[(i+1)%vids.length]; if (v.readyState>=4) load(nx); else v.addEventListener('canplaythrough', function(){ load(nx); }, {once:true});   // the next route waits for this one
      placeName.textContent=v.dataset.place; hud(v);
    }
    vids.forEach(function(v,i){ v.addEventListener('ended', function(){ cur=(i+1)%vids.length; show(cur); }); });

    // ---- scroll ----
    function update(){
      raf=0;
      var h0=headerBottom(); if (h0!==hh || window.innerHeight-h0!==avail){ layout(); return; }
      var r=track.getBoundingClientRect(), run=Math.max(1, r.height-avail);
      var p=clamp((hh-r.top)/run,0,1); lastP=p;
      var mode = r.top>hh ? 'top' : (r.bottom<hh+avail ? 'end' : 'fixed');
      if (mode!==pin || mode==='fixed'){
        pin=mode;
        if (mode==='fixed'){ sticky.style.position='fixed'; sticky.style.top=hh+'px'; sticky.style.left=r.left+'px'; sticky.style.width=r.width+'px'; sticky.style.right='auto'; }
        else { sticky.style.position='absolute'; sticky.style.left='0'; sticky.style.right='0'; sticky.style.width='auto'; sticky.style.top=(mode==='top'?0:run)+'px'; }
      }
      var t=reduce ? (p>T.zoomA?1:0) : ease(band(p,T.zoomA,T.zoomB));
      var s0=Math.max(sw/q.w, sh/q.h)*1.04, s=Math.pow(s0,1-t);
      var k=(s*q.w - q.w)/(s0*q.w - q.w);                          // straight push: centre moves with the screen's width
      var endX=(sw-sceneW)/2 + q.x + q.w/2, endY=(sh-sceneH)/2 + q.y + q.h/2;
      var cx=endX + (sw/2-endX)*k, cy=endY + (sh/2-endY)*k;
      scene.style.transform='translate('+(cx - s*(q.x+q.w/2))+'px,'+(cy - s*(q.y+q.h/2))+'px) scale('+s+')';
      screen.style.setProperty('--sheen', String(t));

      var h=band(p,T.handA,T.handB), mid=(T.handA+T.handB)/2;
      A.style.opacity=String(1-band(p,.05,.12));
      B1.style.opacity=String(Math.min(band(p,.13,.18), 1-band(p,.25,.29)));   // one line at a time
      B2.style.opacity=String(Math.min(band(p,.30,.35), 1-band(p,.42,.47)));
      place.style.opacity=String(1-band(p,.08,.15));
      hint.style.opacity=String(1-band(p,.01,.05));
      note.style.opacity=String(band(p,.46,.52)*(1-h)*.9);
      note.classList.toggle('on-paper', h>.5);
      shade.style.opacity=String((1-t*.6)*(1-h));
      orbitWrap.style.opacity=String(h); paper.style.opacity=String(h);
      var inset=mq.matches?10:16, bw0=Math.min(sw-2*inset, 1560), b0={x:(sw-bw0)/2, y:inset, w:bw0},
          b1={x:card.x+inset, y:(sh-card.y-card.h)+inset, w:card.w-2*inset}, e=ease(h);
      bar.style.left=(b0.x+(b1.x-b0.x)*e)+'px'; bar.style.bottom=(b0.y+(b1.y-b0.y)*e)+'px'; bar.style.width=(b0.w+(b1.w-b0.w)*e)+'px';
      LA.style.opacity=String(1-band(p,T.handA,mid)); LA.style.pointerEvents=h<.5?'auto':'none';
      LB.style.opacity=String(band(p,mid,T.handB));   LB.style.pointerEvents=h>=.5?'auto':'none';
      steps.classList.toggle('on-paper', h>.5);
      stepEls[0].style.setProperty('--f', String(band(p,0,T.zoomA)));
      stepEls[1].style.setProperty('--f', String(band(p,T.zoomA,T.handA)));
      stepEls[2].style.setProperty('--f', String(band(p,T.handA,1)));
      if (p>=T.handA-.12 && !orbit.getAttribute('src')) setFilm(false);       // fetch the film just before the hand-over
      if (p>=T.handA-.02 && !orbitOn){ orbitOn=true; if(!done) setFilm(true); }   // once ended, it stays on the photo
      if (p<T.handA-.06 && orbitOn){ orbitOn=false; orbit.pause(); if(!done) cancelEnd(); }
      if (done){ var st=Math.min(pDone+.03,.95), o=band(p,st,st+.05);        // the photo lands first; the button waits for a little more scroll
        replay.style.opacity=String(o); replay.style.pointerEvents=o>.5?'auto':'none'; }
      if (h>=1){ if (vids[cur]) vids[cur].pause(); } else if (inView && vids[cur] && vids[cur].paused && vids[cur].getAttribute('src')){ vids[cur].play().catch(function(){}); }
    }
    function onScroll(){ if (near && !raf) raf=requestAnimationFrame(update); }

    // ---- orbit films only: a card in the page, no scroll sequence ----
    if (only){
      LB.style.opacity='1'; LB.style.pointerEvents='auto'; if (LA) LA.style.display='none';
      orbitWrap.style.opacity='1'; if (paper) paper.style.opacity='0';
      var showBtn=0;
      update=function(){ if (done && !showBtn){ showBtn=setTimeout(function(){ showBtn=0; if(done){ replay.style.opacity='1'; replay.style.pointerEvents='auto'; } }, 1600); } };   // the photo lands first, then the button
      var layoutO=function(){
        var m=mq.matches, cw=Math.min(sticky.clientWidth, 1560), ca=m?9/16:16/9, ch=cw/ca, inset=m?10:16;
        card={x:0, y:0, w:cw, h:ch};
        stage.style.width=cw+'px'; stage.style.height=ch+'px';
        orbitWrap.style.cssText='left:0;top:0;width:'+cw+'px;height:'+ch+'px;right:auto;bottom:auto;opacity:1';
        bar.style.left=inset+'px'; bar.style.bottom=inset+'px'; bar.style.width=(cw-2*inset)+'px';
        if (orbit.getAttribute('src') && !done) setFilm(false);
      };
      var started=false, filmGo=function(){ if (started) return; started=true; if (!orbit.getAttribute('src')) setFilm(false); if (inView && !done) orbit.play().catch(function(){}); };
      new IntersectionObserver(function(es){ es.forEach(function(en){ if (en.isIntersecting){
        if (document.readyState==='complete') filmGo(); else addEventListener('load', function(){ setTimeout(filmGo, 200); }, {once:true}); } }); },{rootMargin:'600px 0px'}).observe(stage);   // the film waits for the page to load
      new IntersectionObserver(function(es){ es.forEach(function(en){ inView=en.isIntersecting;
        if (inView){ if (started && !ending && !done) orbit.play().catch(function(){}); } else orbit.pause(); }); },{threshold:.35}).observe(stage);
      orbit.addEventListener('play', function(){ if (showBtn){ clearTimeout(showBtn); showBtn=0; } });
      window.addEventListener('resize', layoutO); if (mq.addEventListener) mq.addEventListener('change', layoutO);
      layoutO();
      return;
    }

    // nothing heavy loads until the section is close
    new IntersectionObserver(function(es){ es.forEach(function(en){
      near=en.isIntersecting; if (near){ if (!vids[cur] || !vids[cur].classList.contains('on')) show(cur); update(); }
    }); },{rootMargin:'800px 0px'}).observe(track);
    new IntersectionObserver(function(es){ es.forEach(function(en){
      inView=en.isIntersecting;
      if (inView){ if (vids[cur] && vids[cur].getAttribute('src')) vids[cur].play().catch(function(){}); if (orbitOn && !ending && !done) orbit.play().catch(function(){}); }
      else { if (vids[cur]) vids[cur].pause(); orbit.pause(); }
    }); },{threshold:.02}).observe(track);

    window.addEventListener('scroll', onScroll, {passive:true});
    window.addEventListener('resize', layout);
    if (mq.addEventListener) mq.addEventListener('change', layout);
    layout();
  }

  function boot(){ document.querySelectorAll('[data-ohx]').forEach(function(el){ if(!el.__ohx){ el.__ohx=1; init(el); } }); }
  if (document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
